/* unplugin-vue-components disabled */import script from "./upload-file-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./upload-file-item.vue?vue&type=script&setup=true&lang=ts"

import "./upload-file-item.vue?vue&type=style&index=0&id=c3dccda8&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/vue-ddm-quiz-pc-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3dccda8"]])

export default __exports__